import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { OutlinedInput } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import FormControl from '@mui/material/FormControl';
import React, { FC, useState } from 'react';
import { white } from '../Constants/Colors';

interface IMultiselectOptionTextInputProps {
  value: string;
  options: string[];
  label: React.ReactNode;
  disabled?: boolean;
  onChange: (value: string, evt: SelectChangeEvent<string[]>) => void;
}

const MenuProps = {
  MenuListProps: {
    dense: true
  }
};

const VALUE_SEPARATOR = '; ';

export const MultiselectOptionTextInput: FC<
  IMultiselectOptionTextInputProps
> = ({ label, value, options, onChange, disabled = false }) => {
  //const dispatch = useAppDispatch();
  const [localValue, setLocalValue] = useState(
    (value?.length && value.split(VALUE_SEPARATOR).filter((v) => v)) || []
  );
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value }
    } = event;
    // On autofill we get a stringified value.
    const newValue = typeof value === 'string' ? value.split(',') : value;
    setLocalValue(newValue);
    onChange(newValue.join(VALUE_SEPARATOR), event);
  };
  return (
    <FormControl
      fullWidth
      size="small"
      sx={{ background: white }}
      disabled={disabled}>
      <InputLabel sx={{ fontSize: 14 }}>{label}</InputLabel>
      <Select
        multiple
        value={localValue}
        input={<OutlinedInput label={label} />}
        onChange={handleChange}
        renderValue={(selected) =>
          selected
            ? selected.map((text, idx) => (
                <React.Fragment key={idx}>
                  {text}
                  <br />
                </React.Fragment>
              ))
            : ''
        }
        MenuProps={MenuProps}>
        {options.map((optionValue) => {
          return (
            <MenuItem key={optionValue} value={optionValue}>
              <Checkbox checked={localValue.includes(optionValue)} />
              <ListItemText primary={optionValue} />
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
